import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { pull } from 'lodash';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'ihm-multi-select-chips-list',
  templateUrl: './ihm-multi-select-chips-list.component.html',
  styleUrls: ['./ihm-multi-select-chips-list.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IhmMultiSelectChipsListComponent),
      multi: true
    }
  ]
})
export class IhmMultiSelectChipsListComponent implements OnInit, OnDestroy, ControlValueAccessor {
  // Component Properties
  @Input() readonly optionsList: Array<any> = [];
  @Input() readonly valueProperty: string;
  @Input() readonly displayProperty: string;
  @Input() readonly fieldLabel: string;

  // Form Controls
  selectControl: FormControl = new FormControl([]);

  // Chip List Properties
  chipsList: Array<any> = [];
  formattedOptionsList: Array<any> = [];

  private ngUnsubscribe: Subject<boolean> = new Subject();

  ngOnInit(): void {
    this.formattedOptionsList = !!this.valueProperty ? this.optionsList.map(option => option[this.valueProperty]) : this.optionsList;

    this.listenControlValueChanges();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  removeChip(selectedChip): void {
    this.chipsList = pull(this.chipsList, selectedChip);
    const options: Array<any> = this.getValuesChipsList();
    this.selectControl.setValue(options);
  }

  getDisplayTextOptionItem(option: any): string {
    return !!this.displayProperty ? option[this.displayProperty] : option;
  }

  getValueOptionItem(option: any): string {
    return !!this.valueProperty ? option[this.valueProperty] : option;
  }

  writeValue(selectedOptions: Array<any>): void {
    this.selectControl.setValue(selectedOptions);
    this.updateChipsList(selectedOptions);
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {}
  propagateChange = (value: any) => {};

  private getOptionsChipsList(values: Array<any>): Array<any> {
    return !this.valueProperty ? values : this.optionsList.filter(option => values.some(value => value === option[this.valueProperty]));
  }

  private getValuesChipsList(): Array<any> {
    return !this.valueProperty ? [...this.chipsList] : [...this.chipsList.map(option => option[this.valueProperty])];
  }

  private listenControlValueChanges(): void {
    this.selectControl.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((selectedOptions: Array<any>) => {
      this.updateChipsList(selectedOptions);
      this.propagateChange(selectedOptions);
    });
  }

  private updateChipsList(selectedOptions: Array<any>): void {
    this.chipsList = [];
    this.getOptionsChipsList(selectedOptions).forEach((option: any) => {
      this.chipsList.push(option);
    });
  }
}
